// extracted by mini-css-extract-plugin
export var flex = "Footer-module--flex--4ab0f";
export var flexSection = "Footer-module--flex-section--ff9f6";
export var footer = "Footer-module--footer--34cdd";